import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  globalDiscounts: [],
};

const getters = {
  allGlobalDiscounts: (state) => state.globalDiscounts,
};

const actions = {
  async fetchGlobalDiscounts({ commit }, params = {}) {
    try {
      const response = await axios.get("/global-discount", {
        params: prm(params),
      });

      commit("setGlobalDiscounts", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch global discounts:", error);
    }
  },
  async createGlobalDiscount({ commit }, globalDiscount) {
    try {
      const response = await axios.post("/global-discount", globalDiscount);
      commit("addGlobalDiscount", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create global discount:", error);
      throw error;
    }
  },
  async fetchGlobalDiscountById(_, id) {
    try {
      const response = await axios.get(`/global-discount/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch global discount:", error);
      throw error;
    }
  },
  async updateGlobalDiscount({ commit }, globalDiscount) {
    try {
      const response = await axios.put(`/global-discount/${globalDiscount.id}`, globalDiscount);
      commit("updateGlobalDiscount", response.data);
    } catch (error) {
      console.error("Failed to update global discount:", error);
      throw error;
    }
  },
  async deleteGlobalDiscountById({ commit }, id) {
    try {
      const response = await axios.delete(`/global-discount/${id}`);
      commit("removeGlobalDiscount", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete global discount:", error);
      throw error;
    }
  },
};

const mutations = {
  setGlobalDiscounts(state, globalDiscounts) {
    state.globalDiscounts = [...globalDiscounts.data]; // Ensure this matches your API's response structure
  },
  addGlobalDiscount(state, globalDiscount) {
    state.globalDiscounts.unshift(globalDiscount);
  },
  updateGlobalDiscount(state, updatedGlobalDiscount) {
    const index = state.globalDiscounts.findIndex(
      (globalDiscount) => globalDiscount.id === updatedGlobalDiscount.id
    );
    if (index !== -1) {
      state.globalDiscounts.splice(index, 1, updatedGlobalDiscount);
    }
  },
  removeGlobalDiscount(state, id) {
    console.log("REMOVE TABLE: ", id);
    state.globalDiscounts = state.globalDiscounts.filter((globalDiscount) => globalDiscount.id != id);

    console.log("STATE TABLES: ", state.globalDiscounts);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
